import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faExclamationTriangle, faTrash, faX, faPlusCircle, faChevronDown,faEdit } from '@fortawesome/free-solid-svg-icons';
import '../Css/Animation.css';
import {Loader , Spinner} from '../Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages'
import { validate } from '../CommenResponseAndErrorHandlers/commenUiErrorHandlers';
import { decryptData } from '../../utils/storageCrypto';

//import Dropdown from './DropDown'
// Custom hook to handle outside clicks
const useOutsideClick = (ref, callback) => {
  React.useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [ref, callback]);
};

const CustomDropdown = ({ options = [], selected, onSelect, labelField, valueField, placeholder, onAddNew,showActions = false , onEdit }) => {
    options = Array.isArray(options) ? options : [];

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [focusedOptionIndex, setFocusedOptionIndex] = useState(null);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);


  useOutsideClick(dropdownRef, () => setIsOpen(false));

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
        searchInputRef.current.focus();
    }
}, [isOpen]);

  // Filter options based on the search term
 const safeOptions = Array.isArray(options) ? options : [];

const filteredOptions = safeOptions.filter(option => {
  const label = option?.[labelField] || '';
  return label.toLowerCase().includes(searchTerm.toLowerCase());
});
  const handleOptionClick = (name, id) => {
    onSelect(name, id);
    setIsOpen(false);
    setFocusedOptionIndex(null);
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (!isOpen) {
          setIsOpen(true);
        }
        setFocusedOptionIndex(prevIndex => {
          const newIndex = prevIndex === null ? 0 : Math.min(prevIndex + 1, filteredOptions.length - 1);
          scrollToOption(newIndex);
          return newIndex;
        });
         break;
      case 'ArrowUp':
        e.preventDefault();
        if (!isOpen) {
          setIsOpen(true);
        }
        setFocusedOptionIndex(prevIndex => {
          const newIndex = prevIndex === null ? filteredOptions.length - 1 : Math.max(prevIndex - 1, 0);
          scrollToOption(newIndex);
          return newIndex;
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (focusedOptionIndex !== null) {
          const selectedOption = filteredOptions[focusedOptionIndex];
          handleOptionClick(selectedOption[labelField], selectedOption[valueField]);
        }
        break;
      default:
        break;
    }
  };
  const scrollToOption = (index) => {
    const optionElements = dropdownRef.current.querySelectorAll('div[data-index]');
    if (optionElements && optionElements[index]) {
      optionElements[index].scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }
  };


  return (
    <div className="relative w-1/3" ref={dropdownRef}>
      <div
        className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>
          {selected || placeholder}
        </span>
        <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
      </div>
      {isOpen && (
       <div className="absolute mt-1 w-full max-h-40 bg-white border border-gray-300 rounded-md shadow-md z-10 flex flex-col">
          <input
            type="text"
            className="p-1 border rounded-md border-blue-500 focus:outline-none hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus={isOpen}

          />
          <div className="overflow-y-auto scrollbar-visible flex-grow">
          {filteredOptions.length ? (
          safeOptions
  .filter(option => {
    const label = option?.[labelField] || '';
    return label.toLowerCase().includes(searchTerm.toLowerCase());
  })
  .map((option, index) => (
             <div
  key={option[valueField]}
  data-index={index}
  className={`p-2 cursor-pointer text-sm ${
    index === focusedOptionIndex ? 'bg-blue-300 text-white' : ''
  } hover:bg-blue-300 hover:text-white`}
  onClick={() => handleOptionClick(option[labelField], option[valueField])}
>
  <div className="flex flex-col w-full">

    {/* First Row */}
    <div className="flex justify-between items-center">
      <span className="font-medium">
        {option[labelField]}
      </span>
  {showActions && option[valueField] !== 'ALL' && (
      <div className="flex items-center space-x-2 mr-3">
        {/* EDIT ICON */}
        <FontAwesomeIcon
          icon={faEdit}
          className="text-gray-500 hover:text-blue-600 cursor-pointer"
          onClick={(e) => {
    e.stopPropagation(); // prevent dropdown select
    // Pass the option to parent component via props
    if (onEdit) {
      onEdit(option);
    }
  }}
        />

       
      </div>
)}
    </div>

    {/* Second Row */}
    <div className="text-xs mt-1 flex flex-wrap gap-2">

      {option.level && (
        <span className="bg-gray-100 text-gray-600 px-1 rounded">
          {option.level}
        </span>
      )}

      {option.filterable !== undefined && (
        <span
          className={`px-1 rounded ${
            option.filterable
              ? 'bg-blue-100 text-blue-600'
              : 'bg-red-100 text-red-600'
          }`}
        >
          {option.filterable ? 'Filterable' : 'Non-filterable'}
        </span>
      )}

      {option.discountable !== undefined && (
        <span
          className={`px-1 rounded ${
            option.discountable
              ? 'bg-blue-100 text-blue-600'
              : 'bg-red-100 text-red-600'
          }`}
        >
          {option.discountable
            ? 'Discountable'
            : 'Non-Discountable'}
        </span>
      )}
    </div>

  </div>
</div>



            ))
          ) : (
            <div className="p-2 text-gray-500">No results found</div>
          )}
          </div>
          {onAddNew && (
            <button
              type="button"
              className="flex items-center border-t p-2 mt-2 text-blue-500 "
              onClick={onAddNew}
            >
              <FontAwesomeIcon icon={faPlusCircle} className="w-4 h-4 mr-2" />
              Add New
            </button>
          )}
        </div>
      )}
    </div>
  );
};
const ProductAttributes = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [productCategories, setProductCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCategoryId , setSelectedCategoryId] = useState();
  const [attributes, setAttributes] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState('');
  const [showNewAttributePopup, setShowNewAttributePopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
  const [attributeName, setAttributeName] = useState('');
  const [productCategoryId, setProductCategoryId] = useState('');
  const [SelectedAttributeNameId,setSelectedAttributeNameId] = useState()
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [errors, setErrors] = useState({});
const [rows, setRows] = useState([
  { SNo: '', Name: '', Values: '', attribute_name_id: '', level: '', filterable: null, discountable:null }
]);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [roleId, setRoleId] = useState(null);
   const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [productSubCategories, setProductSubCategories] = useState([]);
const [productGroups, setProductGroups] = useState([]);
const [filterable, setFilterable] = useState(true); // default YES
const [discountable,setDiscountable] = useState(false);
const [showEditAttributePopup, setShowEditAttributePopup] = useState(false);
const [editingAttribute, setEditingAttribute] = useState(null);
const [description, setDescription] = useState('');


    const handleInputChange = (index, field, value) => {
      const updatedRows = [...rows];
      updatedRows[index][field] = value;
      setRows(updatedRows);
    };
  
const addRow = () => {
  if (SelectedAttributeNameId === 'ALL') {
    setPopupMessage('Please select a specific attribute to add values');
    setPopupType('400');
    setShowPopup(true);
    return;
  }

  const selectedAttrObj = attributes.find(
  attr => attr.attribute_name_id === SelectedAttributeNameId
);


  if (selectedCategoryId && SelectedAttributeNameId) {
    setRows([
      ...rows,
      {
        SNo: '',
        Name: selectedAttribute,
        Values: '',
        attribute_name_id: SelectedAttributeNameId,
        level: selectedAttrObj?.level,
        filterable: selectedAttrObj?.filterable,
        discountable: selectedAttrObj?.discountable
      }
    ]);
  }
};

    const deleteRow = (index ,row) => {
      if(row?.attribute_value_id && row?.attribute_value_delete){
        handleDeleteAttributeValue(index, row)
        
      }else{
        const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
        setRows(updatedRows);
      }
     
    };

    const handleDeleteAttributeValue = async (index, row,attempt = 1) => {
      try {
            const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

        const response = await fetch(`${fetchUrl}product-attributes/delete-attribute-value?attribute_value_id=${row.attribute_value_id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        });
    
        const output = await handleDeleteResponse(response);
        if (output) {
          const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
          setRows(updatedRows);
        }
    
      } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleDeleteAttributeValue(index, row,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleDeleteAttributeValue(index, row,attempt)); // Set retry function
      }
    }
    }
    
    const handleDeleteResponse = (response) => {
      if (response.status === 204) {
        // No content, but successful deletion
        setIsSaving(false);
        setPopupMessage('Attribute value deleted successfully.');
        setPopupType('204');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        return true;
      } else if (response.status === 200 || response.status === 201) {
        setIsSaving(false);
        setPopupMessage('Attribute value deleted successfully.');
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        return true;
      } else {
        response.json().then(data => {
          setIsSaving(false);
          setPopupMessage(data.message || 'An error occurred.');
          setPopupType(`${response.status}`);
          setShowPopup(true);
        });
        return false;
      }
    }
    

    const fetchProductCategories = async (attempt = 1) => {
      try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        const response = await fetch(fetchUrl + "product-category/get-all-productCategories", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });         
        const data = await response.json();        
        if (data.status === 200 || data.status === 201 || data.status === 204) {
          // Map data to expected format
          const categories = data.data.map(cat => ({
            product_category_id: cat._id,
            product_category_name: cat.product_category_name
          }));
          setProductCategories(categories);
        } else {
          setIsSaving(false);
          setPopupMessage(data.message);
          setPopupType(`${data.status}`);
          setShowPopup(true);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => fetchProductCategories(attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchProductCategories(attempt)); // Set retry function
        }
      }finally {
        setIsLoading(false);
      }
    };

const fetchSubProductCategories = async (categoryId, attempt = 1) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${fetchUrl}product-sub-category/get-product-subCategories-and-vendors-by-productCategory?product_category_id=${categoryId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log('subcategories response:', data);

    if (data.status === 200 || data.status === 201) {
setProductSubCategories(data.data.subCategories || []);
    } else {
      setProductSubCategories([]);
    }
  } catch (error) {
    console.error("Failed to fetch subcategories:", error);
  }
};

const fetchProductGroups = async (categoryId) => {
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);
    const encryptedOrganizationId = sessionStorage.getItem('organizationId');
              const organizationId = decryptData(encryptedOrganizationId);

    const url = `${fetchUrl}product-groups/get-productGroups-by-productCategory?product_category_id=${categoryId}&organizationId=${organizationId}`;
    console.log("Groups API URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    if (!response.ok) {
      console.error("API error:", response.status);
      setProductGroups([]);
      return;
    }

    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      setProductGroups(data.data || []);
    } else {
      setProductGroups([]);
    }

  } catch (error) {
    console.error("Failed to fetch groups:", error);
  }
};
    

    useEffect(() => {
      fetchRoleId();
      fetchProductCategories();
    }, [fetchUrl]);

    useEffect(() =>{
      if(selectedCategoryId || selectedSubCategory?.id || selectedGroup?.id){
      fetchAttributes()
    }
    },[selectedCategoryId,selectedSubCategory?.id,selectedGroup?.id])

    const fetchRoleId = () => {
      const encryptedroleId = sessionStorage.getItem('roleId');
      const sroleId = decryptData(encryptedroleId)
      setRoleId(sroleId);
    };

    const categoriesToDisplay = roleId === 6 
    ? productCategories.filter(category => (category.product_category_name.toLowerCase()) === 'tiles')
    : productCategories;


 const handleCategoryChange = async (name, id) => {
  setSelectedCategory(name);
  setSelectedCategoryId(id);

  //fetchAttributes(/* id */);
  fetchSubProductCategories(id);
  fetchProductGroups(id);   // ✅ add this line

  setSelectedSubCategory(null);
  setSelectedGroup(null);
};

const handleAttributeSelect = async (name, id) => {
  setSelectedAttribute(name);
  setSelectedAttributeNameId(id);

  if (id === 'ALL') {
    await getAllAttributesValues();   // ✅ new function
  } else {
    getattributeValuesByAttributeNameId(id, name);
  }
};

  const getattributeValuesByAttributeNameId = async (id,name,attempt = 1) => {
        const encryptedToken = sessionStorage.getItem('token');
        const token = decryptData(encryptedToken);

    const saveUrl = `${fetchUrl}product-attributes/get-all-attribute-values-by-name-id?attribute_name_id=${id}`;
  
    try {
      const response = await fetch(saveUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });
      const Data = await response.json();
        const output = await getResponseHandling(response,Data)
      if (output) {

        const selectedAttrObj = attributes.find(
          attr => attr.attribute_name_id === id
        );
      
        const data = output.map ((row , index)=>({
          SNo: index + 1,
          Name: name,
          Values: row.attribute_value,
          attribute_name_id: row.attribute_name_id,
          attribute_value_id:row._id,        
          attribute_value_delete : row.attribute_value_delete,
          level: selectedAttrObj?.level,
          filterable: selectedAttrObj?.filterable,
          discountable: selectedAttrObj?.discountable
        }))
        setRows(data)
      } else {
        const data= [{
          SNo:  1,
          Name: name,
          Values: '' ,
          attribute_name_id: id,
        }];
        setRows(data) ;       
      }
    }  catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => getattributeValuesByAttributeNameId(id,name,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => getattributeValuesByAttributeNameId(id,name,attempt)); // Set retry function
      }
    }
  }
  const getResponseHandling = async (response, data)=>{
    if (response.status === 200 || response.status === 201) {
      setPopupType('200or201');
        return (data.data)
    } else if (response.status === 204) {
      setPopupType('204');
      return (data.data)
    } 
 
    if (response.status === 400) {
      setPopupType('400');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 401) {
      setPopupType('401');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 403) {
     
      setPopupType('403');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 404) {
      return null
    } 
     else if (response.status === 500) {
     
      setPopupType('500');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else {
      setErrorMessages([...errorMessages, data.message]);
    }
  
}

  const fetchAttributes = async (/* categoryId, */attempt = 1) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
          const categoryId = selectedCategoryId || selectedCategory?.id;
          const subCategoryId = selectedSubCategory?.id || null;
          const groupId = selectedGroup?.id || null;

      const response = await fetch(`${fetchUrl}product-attributes/get-attr?product_category_id=${categoryId}&product_sub_category_id=${subCategoryId}&product_group_id=${groupId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });
      const data = await response.json();
      console.log(data);
      const output = await getResponseHandling(response,data)
            if (output) {
     /*    const formattedAttributes = output.map(attr => ({
          attribute_name: attr.attribute_name,
          attribute_name_id: attr.attribute_name_id
        })); */
        const formattedAttributes = output.map(attr => ({
          attribute_name: attr.attribute_name,
          attribute_name_id: attr.attribute_name_id,
          level: attr.level,
          filterable: attr.filterable,
          discountable: attr.discountable
        })).sort((a, b) => a.attribute_name.localeCompare(b.attribute_name));

        // ✅ Add "All" option at top
        const attributesWithAll = [
          {
            attribute_name: 'All',
            attribute_name_id: 'ALL'
          },
          ...formattedAttributes
        ];

        setAttributes(attributesWithAll);
        setRows([{ SNo: 1, Name: '', Values: '', attribute_name_id: '' }])
        setSelectedAttribute('')
        return formattedAttributes;
      } else {
        setAttributes([])
        setSelectedAttribute('')
        setSelectedAttributeNameId()
        setRows([{ SNo: 1, Name: '', Values: '', attribute_name_id: '' }])
        return [];
      }
    }catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchAttributes(/* categoryId, */attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchAttributes(/* categoryId, */attempt)); // Set retry function
      }
    }
  };
  
 
  const handleAddNewAttribute = () => {
    const fields = [ 
      { name: 'product_category', value: selectedCategoryId, required: true,  message: 'select a product category ', usage: 'product category'},  
    ];
    const validationErrors = validate(fields);
    setErrors(validationErrors);

    // Proceed only if there are no validation errors
    if (Object.keys(validationErrors).length === 0) {
    setShowNewAttributePopup(true);
    setAttributeName('')
    setFilterable(true); // default YES every time popup opens
    setDiscountable(false);
    }
    }
  
  const handleClosePopup = () => {
    setShowPopup(false);
    setShowNewAttributePopup(false);
  };
 
  const clearAllData = () => {
  // Clear all state variables
  setRows([{ SNo: '', Name: '', Values: '', attribute_name_id: '', level: '', filterable: null, discountable: null }]);
  setSelectedAttribute('');
  setSelectedAttributeNameId(null);
  setSelectedCategory('');
  setSelectedCategoryId(null);
  setSelectedSubCategory(null);
  setSelectedGroup(null);
  setAttributes([]);
  setProductSubCategories([]);
  setProductGroups([]);
  setErrors({});
};
  
  
  const handleSave = async (attempt = 1) => {
    const data = {
      product_category_id: selectedCategoryId,
      product_sub_category_id: selectedSubCategory?.id,
      product_group_id: selectedGroup?.id,
      attribute_name: attributeName,
      filterable: filterable,
      discountable: discountable
    };
    const errorMessages = [];
    if (!data.attribute_name) {
      errorMessages.push('Please enter Attribute Name');
    }
 
    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      return;
    }

    setIsSaving(true);
    try {
          const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);

      const saveUrl = `${fetchUrl}product-attributes/create-attr`;
  
      const response = await fetch(saveUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(data),
      });
      const Data = await response.json();
      const output = await SaveResponseHandling (response ,Data)
      if (output) {
       fetchAttributes(/* selectedCategoryId */)
       //setShowPopup(false);
       setShowNewAttributePopup(false);
      } else {
        if(response.status === 409){
          errorMessages.push(`Attribute ${data.attribute_name} is alredy exist`);
          setErrorMessages(errorMessages)
        }
        
        console.error(Data.message);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleSave(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleSave(attempt)); // Set retry function
      }
    }
  }

  const SaveResponseHandling = (response, data)=>{
    if (response.status === 200 || response.status === 201) {
      setIsSaving(false);
      setPopupMessage(data.message);
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
      return data.data
    } else if (response.status === 204) {
      setIsSaving(false);
      setPopupMessage(data.message);
      setPopupType('204');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);

      return data.data
    } else {
      setIsSaving(false);
      setPopupMessage(data.message);
      setPopupType(`${response.status}`);
      setShowPopup(true);
      return null
    }
  }
  
  
const handleAttributesData = (data) => {
  return data.map((item) => ({
    attribute_name_id: item.attribute_name_id,
    attribute_value: item.Values,
    attribute_value_id: item.attribute_value_id || null // Ensure attribute_value_id is present or null
  }));
}

const handleSaveAttributeValues = async (attempt = 1) => {
  const hasMissingName =  rows.some((item) => !item.Values || item.Values.trim() === '');
    
    const fields = [
      { name: 'attribute_value', value: !hasMissingName, required: true,  message: 'attribute value is required', usage: 'attribute value', },
      { name: 'product_category', value: selectedCategoryId, required: true,  message: 'select a Item category ', usage: 'product category'},
      { name: 'attribute_name', value: selectedAttribute, required: true,  message: 'select a Attribute', usage: 'Attribute'},
    ];

    const validationErrors = validate(fields);
    setErrors(validationErrors);

    // Proceed only if there are no validation errors
    if (Object.keys(validationErrors).length === 0) {
  const attributesData = handleAttributesData(rows)
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

  const url = fetchUrl + 'product-attributes/create-attribute-values-by-name-id'; // Update '/your-endpoint' to the correct endpoint
 console.log(attributesData)
 setIsSaving(true);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify({ attribute_values: attributesData }) // Wrap rows in an object
    });
    const Data = await response.json();
    if (Data.status === 200 || Data.status === 201) {
      setIsSaving(false);
      // getattributeValuesByAttributeNameId(SelectedAttributeNameId,selectedAttribute )
      setPopupMessage(Data.message);
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        clearAllData();
        navigate('/bb/app/items/productattributes');
      }, 3000);
      
    } else if (Data.status === 204) {
      setIsSaving(false);
      setPopupMessage(Data.message);
      setPopupType('204');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate('/bb/app/items//productattributes');
      }, 3000);
    } else if (Data.status === 409) {
      if(response.status === 409){
        const error = {
          duplication : Data.message
        }
        setErrors(error)
        setIsSaving(false);
      }
    
    } else {
      setIsSaving(false);
      setPopupMessage(Data.message);
      setPopupType(`${Data.status}`);
      setShowPopup(true);
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => handleSaveAttributeValues(attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleSaveAttributeValues(attempt)); // Set retry function
    }
  }
}
}

const handleCloseError = () => {
  setErrorMessages([]);
};

const closePopup = () => {
  console.log("closePopup called");
  setShowPopup(false);
};

const Retry = async() => {
  console.log("Retry called");
  setTimeout(async ()=>{
    if(retryFunction){

      await retryFunction ();
    }

    setIsLoading(false)
  },1000)
  
  setShowPopup(false);
};

const BackToLoginPage = () => {
  console.log("Back To Login Page");
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/bb');
};

const handleStayHere = () => {
  setShowCancelPopup(false);
}

const handleCancel = () => {
  setShowCancelPopup(true);
}

const handleLeave = () => {
  navigate(-1);
}

const handleProductSubcategory = (name, id) => {
  setSelectedSubCategory({
    id: id,
    name: name
  });
  //fetchAttributes(/* id */);
  setSelectedGroup(null);
};

const handleGroupSelect = (name, id) => {
  setSelectedGroup({
    id: id,
    name: name
  });
  //fetchAttributes(/* id */);
};

const getAllAttributesValues = async (attempt = 1) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const categoryId = selectedCategoryId;
    const subCategoryId = selectedSubCategory?.id || null;
    const groupId = selectedGroup?.id || null;

    const response = await fetch(
      `${fetchUrl}product-attributes/get-attr?product_category_id=${categoryId}&product_sub_category_id=${subCategoryId}&product_group_id=${groupId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    const output = await getResponseHandling(response, data);

    if (output) {
      let allRows = [];

      for (let attr of output) {
        const valuesRes = await fetch(
          `${fetchUrl}product-attributes/get-all-attribute-values-by-name-id?attribute_name_id=${attr.attribute_name_id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-token': token,
            },
          }
        );

        const valuesData = await valuesRes.json();
        const valuesOutput = await getResponseHandling(valuesRes, valuesData);

        if (valuesOutput && valuesOutput.length > 0) {
          const mapped = valuesOutput.map((val, index) => ({
            SNo: allRows.length + index + 1,
            Name: attr.attribute_name,
            Values: val.attribute_value,
            attribute_name_id: attr.attribute_name_id,
            attribute_value_id: val._id,
            attribute_value_delete: val.attribute_value_delete,
            level: attr.level,
            filterable: attr.filterable,
            discountable: attr.discountable
          }));

          allRows = [...allRows, ...mapped];
        } else {
          // if no values still show attribute
          allRows.push({
            SNo: allRows.length + 1,
            Name: attr.attribute_name,
            Values: '',
            attribute_name_id: attr.attribute_name_id,
            level: attr.level,
            filterable: attr.filterable,
            discountable: attr.discountable
          });
        }
      }

      setRows(allRows);
    }
  } catch (error) {
    console.error('Failed to fetch all attributes:', error);

    if (attempt < RETRY_LIMIT) {
      setTimeout(() => getAllAttributesValues(attempt + 1), 1000);
    } else {
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
    }
  }
};


// Add these functions after handleSaveAttributeValues function
const handleEditAttribute = (attribute) => {
  setEditingAttribute(attribute);
  setAttributeName(attribute.attribute_name);
  setDescription(attribute.description || ''); // Add this line
  setFilterable(attribute.filterable !== false);
  setDiscountable(attribute.discountable !== false);
  setShowEditAttributePopup(true);
};

const handleUpdateAttribute = async (attempt = 1) => {
  const data = {
    attribute_name: attributeName,
    description: description,
    filterable: filterable,
    discountable: discountable
  };

  const errorMessages = [];
  if (!data.attribute_name) {
    errorMessages.push('Please enter Attribute Name');
  }

  if (errorMessages.length > 0) {
    setErrorMessages(errorMessages);
    return;
  }

  setIsSaving(true);
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    // ✅ Backend expects: PUT /product-attributes/update-attribute?attribute_id={id}
    const updateUrl = `${fetchUrl}product-attributes/update-attribute?attribute_id=${editingAttribute.attribute_name_id}`;
    
    const response = await fetch(updateUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(data), // ✅ Only send fields that need updating
    });
    
    const Data = await response.json();
    console.log('Update response:', Data);
    const output = await SaveResponseHandling(response, Data);
    
    if (output) {
      await fetchAttributes();
      setShowEditAttributePopup(false);
      setEditingAttribute(null);
    }
  } catch (error) {
    console.error('Failed to update attribute:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => handleUpdateAttribute(attempt + 1), 1000);
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleUpdateAttribute(attempt));
    }
  }
};

const handleCloseEditPopup = () => {
  setShowEditAttributePopup(false);
  setEditingAttribute(null);
  setAttributeName('');
   setDescription('');
  setFilterable(true);
  setDiscountable(false);
};

if (isLoading) {
  return <Loader />;
}


  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">Item Attributes</h1>
                </div>
              </div>
              {Object.keys(errors).length > 0 && (
        <div className="flex justify-between  w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">
          <div className="px-6 flex flex-col space-y-2 justify-start items-start">
            {errors.attribute_name && (
              <span className="text-sm">
                • {errors.attribute_name}
              </span>
            )}
            {errors.product_category && (
              <span className="text-sm">
                • {errors.product_category}
              </span>
            )}
            {errors.attribute_value && (
              <span className="text-sm">
                • {errors.attribute_value}
              </span>
            )}

          {errors.duplication && (
              <span className="text-sm">
                • {errors.duplication}
              </span>
            )}
          </div>
          <div className='px-4'>
            <button
              className="text-gray-700 hover:text-red-500"
              onClick={() => setErrors({})}
            >
              <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
            </button>
          </div>
        </div>
      )}
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">            
                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="categoryname" className="block text-sm font-regular text-[#e54643] w-1/6">Item Category <span className="text-red-500">*</span></label>
                    <CustomDropdown
                      options={categoriesToDisplay}
                      selected={selectedCategory}
                      onSelect={handleCategoryChange}
                      labelField="product_category_name"
                      valueField="product_category_id"
                      placeholder="Select Product Category"
                    />
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="subcategoryname" className="block text-sm font-regular w-1/6">Item Subcategory</label>
                  <CustomDropdown
  options={productSubCategories}
  selected={selectedSubCategory?.name}
  onSelect={handleProductSubcategory}
  labelField="product_sub_category_name"
  valueField="_id"
  placeholder="Select Subcategory"
/>
               
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="categoryname" className="block text-sm font-regular w-1/6">Item Group</label>
                 <CustomDropdown
  options={productGroups}
  selected={selectedGroup?.name}
  onSelect={handleGroupSelect}
  labelField="product_group_name"
  valueField="_id"
  placeholder="Select Group"
/>
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="Attribute" className="block text-sm font-regular text-[#e54643] w-1/6">Attribute <span className="text-red-500">*</span></label>
                    <CustomDropdown
        options={attributes}
        selected={selectedAttribute}
        onSelect={handleAttributeSelect}
        labelField="attribute_name"
        valueField="attribute_name_id"
        placeholder="Select an Attribute"
        onAddNew={handleAddNewAttribute} // Pass the onAddNew handler
        showActions={true}
         onEdit={handleEditAttribute}
      />
                  </div>
                </div>

                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-md font-semibold">Attribute Values</h1>
                  
                </div>

                <div className="w-full container mx-auto px-4 mb-2 mt-4">
                  {rows.length > 0 ? (
                  <table className="w-full">
                    <thead>
                      <tr className="text-[#6c7184] bg-[#fafafc]">
                        <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">SNo</th>
                        <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Name</th>
                        <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Values</th>
                      </tr>
                    </thead>
                    <tbody>
                    {rows.map((row, index) => (
                            <tr key={index}>
                              <td className="py-2 px-4 border">{index + 1}</td>
                              <td className="border">
                                <div className="text-sm p-2">
                                  {row.Name}

                                  {row.level && (
                                    <span className="ml-2 text-xs bg-gray-100 px-1 rounded">
                                      ({row.level})
                                    </span>
                                  )}

                                  {row.filterable !== undefined && row.filterable !== null && (
                                    <span className={`ml-2 text-xs px-1 rounded ${
                                      row.filterable ? 'bg-blue-100 text-blue-600' : 'bg-red-100 text-red-600'
                                    }`}>
                                      {row.filterable ? 'Filterable' : 'Non-filterable'}
                                    </span>
                                  )}

                                  {row.discountable !== undefined && row.discountable !== null && (
                                    <span className={`ml-2 text-xs px-1 rounded ${
                                      row.discountable ? 'bg-blue-100 text-blue-600' : 'bg-red-100 text-red-600'
                                    }`}>
                                      {row.discountable ? 'Discountable' : 'Non-Discountable'}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="border">
                                <input
                                  type="text"
                                  value={row.Values}
                                  onChange={(e) => handleInputChange(index, 'Values', e.target.value)}
                                  className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                                />
                              </td>
                              <td className="px-2">
                                <button
                                  type="button"
                                  onClick={() => deleteRow(index ,row)}
                                  className="text-red-500"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  ):(
                    <div className="text-center py-4">
                    <p>No Attributes</p>
                    </div>
                  )}
                </div>

                <div className="mt-4">
                  <button
                    onClick={addRow}
                    className="text-blue-500 py-2 px-4"
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                    Add Attribute Value
                  </button>
                </div>
                </div>

                <div className="mt-5 w-full">
                <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                  <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                    onClick={handleSaveAttributeValues}                  >
                    <span>Save</span>
                    {isSaving && ( <Spinner/>)}
                  </button>
                  <button onClick={handleCancel}  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
                </div>
                </div>   
            </div>
          </div>
        </div>

         {/* Popup starts */}

         {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  <span>Stay Here</span>
    {isSaving && (<Spinner/>)}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}
         {showNewAttributePopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col animate-slide-in">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">New Attribute</h2>
        <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      {errorMessages.length > 0 && (
        <div className='p-1'>
                <div className="mt-1 flex justify-between items-center  px-auto py-1  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                  </div>
                </div>
                </div>
              )}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-6">
        <label htmlFor="uom" className="block text-sm font-regular text-[#e54643] w-1/6">
          Attribute<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="Attribute"
          className="w-[40%] outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
          value={attributeName}
                onChange={(e) => setAttributeName(e.target.value)}
       />
      </div>
      {/* Description Label and Textarea */}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
        <label htmlFor="Description" className="block text-sm font-regular text-gray-700 w-1/6">Description</label>
        <textarea
          id="Description"
          name="Description"
          className="mt-1 w-[40%] outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
          /* value={description}
          onChange={(e)=>{setdescription(e.target.value)}} */
        />
      </div>
      <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
      <label className="block text-sm font-regular text-gray-700 w-1/6">
        Filterable
      </label>

      <div className="flex space-x-4">
        <label className="flex items-center space-x-1">
          <input
            type="radio"
            name="filterable"
            checked={filterable === true}
            onChange={() => setFilterable(true)}
          />
          <span>Yes</span>
        </label>

        <label className="flex items-center space-x-1">
          <input
            type="radio"
            name="filterable"
            checked={filterable === false}
            onChange={() => setFilterable(false)}
          />
          <span>No</span>
        </label>
      </div>
    </div>
          <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
      <label className="block text-sm font-regular text-gray-700 w-1/6">
        Discountable
      </label>

      <div className="flex space-x-4">
        <label className="flex items-center space-x-1">
          <input
            type="radio"
            name="discountable"
            checked={discountable === true}
            onChange={() => setDiscountable(true)}
          />
          <span>Yes</span>
        </label>

        <label className="flex items-center space-x-1">
          <input
            type="radio"
            name="discountable"
            checked={discountable === false}
            onChange={() => setDiscountable(false)}
          />
          <span>No</span>
        </label>
      </div>
    </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
           onClick={handleSave} >
           <span>Save</span>
            {isSaving && <Spinner />}
            </button>
          <button onClick={handleClosePopup}  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
        </div>
      </div>
    </div>
  </div>
)}

{showEditAttributePopup && editingAttribute && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col animate-slide-in">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">Edit Attribute</h2>
        <button onClick={handleCloseEditPopup} className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      {errorMessages.length > 0 && (
        <div className='p-1'>
          <div className="mt-1 flex justify-between items-center px-auto py-1 bg-[#fddcde] rounded-md">
            <div className="px-6 flex flex-col justify-start items-start">
              {errorMessages.map((errorMessage, index) => (
                <span key={index} className="text-sm">
                  - {errorMessage}
                </span>
              ))}
            </div>
            <div className='px-4'>
              <button
                className="text-gray-700 hover:text-red-500"
                onClick={handleCloseError}
              >
                <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ATTRIBUTE NAME FIELD */}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-6">
        <label htmlFor="editAttribute" className="block text-sm font-regular text-[#e54643] w-1/6">
          Attribute<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="editAttribute"
          className="w-[40%] outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
          value={attributeName}
          onChange={(e) => setAttributeName(e.target.value)}
        />
      </div>

      {/* DESCRIPTION FIELD - ADD THIS NEW SECTION */}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
        <label htmlFor="editDescription" className="block text-sm font-regular text-gray-700 w-1/6">Description</label>
        <textarea
          id="editDescription"
          name="editDescription"
          className="mt-1 w-[40%] outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700 resize-vertical"
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter attribute description..."
        />
      </div>

      {/* FILTERABLE RADIO BUTTONS */}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
        <label className="block text-sm font-regular text-gray-700 w-1/6">
          Filterable
        </label>
        <div className="flex space-x-4">
          <label className="flex items-center space-x-1">
            <input
              type="radio"
              name="edit_filterable"
              checked={filterable === true}
              onChange={() => setFilterable(true)}
            />
            <span>Yes</span>
          </label>
          <label className="flex items-center space-x-1">
            <input
              type="radio"
              name="edit_filterable"
              checked={filterable === false}
              onChange={() => setFilterable(false)}
            />
            <span>No</span>
          </label>
        </div>
      </div>

      {/* DISCOUNTABLE RADIO BUTTONS */}
      <div className="w-full flex flex-row items-center mb-4 space-x-2 px-6">
        <label className="block text-sm font-regular text-gray-700 w-1/6">
          Discountable
        </label>
        <div className="flex space-x-4">
          <label className="flex items-center space-x-1">
            <input
              type="radio"
              name="edit_discountable"
              checked={discountable === true}
              onChange={() => setDiscountable(true)}
            />
            <span>Yes</span>
          </label>
          <label className="flex items-center space-x-1">
            <input
              type="radio"
              name="edit_discountable"
              checked={discountable === false}
              onChange={() => setDiscountable(false)}
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button 
            className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
            onClick={handleUpdateAttribute}
            disabled={isSaving}
          >
            <span>Update</span>
            {isSaving && <Spinner />}
          </button>
          <button 
            onClick={handleCloseEditPopup}
            className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
              isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
            }`}
            disabled={isSaving}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
  </div>
)}
{/* Popup ends */}
      </div>
       
    </div>
  );
};

export default ProductAttributes;
